<template>
  <AppLink :to="url">
    <ArticleContentRenderer
      v-if="children"
      :content="children"
      :preloaded-data="preloadedData"
    />
  </AppLink>
</template>

<script lang="ts" setup>
  import ArticleContentRenderer from './ArticleContentRenderer.vue';
  import type { PreloadedData } from './lib/articleComponents';
  import type { ArticleContent } from './models/ArticleContent';

  export interface Props {
    url: string;
    children?: ArticleContent;
    preloadedData: PreloadedData;
  }

  defineProps<Props>();
</script>
